import { AlkLogger } from '@alk/core';
import { injectable } from 'inversify';
import { IQuoteResponse } from '../../../interfaces';
import { ISubscriptionPoolingService } from './subscription-pooling.interface';
import { Observable, of } from 'rxjs';

@injectable()
export class SubscriptionPoolingMock implements ISubscriptionPoolingService {
    unsubscribe(): void {
        return;
    }
    create(): string {
        throw new Error('Method not implemented.');
    }
    spotPriceObservable(): Observable<IQuoteResponse> {
        AlkLogger.debug('SubscriptionPoolingMock#spotPriceObservable');
        return of({} as IQuoteResponse);
    }
    shouldResubscribeObservable(): Observable<void> {
        AlkLogger.debug('SubscriptionPoolingMock#shouldResubscribeObservable');
        return of(null);
    }
}
